import { matomoState } from "./state";

export function registerMatomoRouter(router: any, nuxt: any) {
    router.afterEach((to: any, from: any) => {
        requestIdleCallback(async () => {
            try {
                const matomo = useMatomo();

                if (matomo) {
                    await matomo.trackPageView(nuxt, to, from);

                    const { path, article } = nuxt.$client.page;

                    // Tracking product views.
                    useMtmPush({
                        event: 'productView',
                        products: article?.products.map((product: any) => ({
                            id: product.quantity === 1
                                ? product.productCode
                                : `${product.productCode}-MPX${product.quantity}`,
                            name: product.productName,
                            category: path.substring(0, path.lastIndexOf('/'))
                        }))
                    });
                }
            } catch (err) {
                console.error('[Matomo] Error tracking page view:', err);
            }
        });
    });
}

export const useMtmPush = (args: any) => {
    if (!import.meta.client) return;

    if (!matomoState.ready) {
        matomoState.queue.push(() => {
            window._mtm.push(args);
        });
    } else {
        window._mtm = window._mtm || [];
        window._mtm.push(args);
    }
}
